
import { useState } from "react";
import { useSelector } from "react-redux";
import { Box, Grid, Typography} from "@mui/material";
import { TablaCotizacionCliente } from "../components";
import { descargarPDF } from "../../../helpers/descargarArchivo";
import { BackdropScreen } from "../../components";
import { LayoutCrearDoc } from "../../layouts";
import { BotonesAndCargando } from "../../components/botones";
import { useAuthStore, useGlobalValueStore, useUsuariosStore } from "../../../stores";
import { useListCarritoXUser } from "../../../hooks/cache";
import { descargarAndGuardarCarrito } from "../../../services";



const empresa = require.context('../../../assets/empresa', true);




export const CotizacionScreen = () => {

    const { usuario } = useAuthStore();
    const { view } = useSelector( state => state.iva );
    const { data } = useListCarritoXUser(usuario.id);
    const { usuarioVenta } = useUsuariosStore();
    const { observacionCotizacion } = useGlobalValueStore();
    const [cargando, setCargando] = useState(false)




    const generarCotizacionCarrito = async() => {
        const titulo = `Cotizacion-${usuarioVenta.nombre}`
        setCargando(true);
        const idsCarrito = data.map( item => item.id );
        const datos = await descargarAndGuardarCarrito({ idsCarrito, observacion: observacionCotizacion, view, user: usuarioVenta.id });
        setCargando(false);
        descargarPDF(datos, titulo);
    }



    return (

        <LayoutCrearDoc titulo='Cotización' add={false} >
            <BackdropScreen cargando={cargando} titulo='espere por favor estamos generando su cotización...' />

            <Grid container sx={{width:'100%', display:'flex', flexDirection:'column', alignContent:'center', justifyContent:'center', mt:4}}>
                <img src={ empresa(`./sevennegro.png`) } style={{width:110}} className="img-coti" />
                <Typography variant="h3" color="secondary" sx={{textAlign:'center'}}>Seven For Ever S.A.S.</Typography>
                <Typography variant="h3" color="secondary" sx={{textAlign:'center'}}>NIT: 901253145-3 Régimen Común</Typography>
                <Typography variant="h3" color="primary" sx={{textAlign:'center'}}>PUBLICIDAD PERSONALIZADOS BORDADOS</Typography>
            </Grid>

            <Box sx={{ width:'100%', my:2 }}>
                <Typography variant="h3" color="secondary" sx={{ fontSize:'17px', textAlign:'center' }}> 
                    Atendiendo su solicitud estamos enviando cotización de los productos y servicios requeridos, para nosotros es un placer poner nuestra compañia a su servicio.
                </Typography>

                <Typography variant="h3" color="secondary" className="cambia-color" sx={{ fontSize:'19px', textAlign:'center' }}> 
                    Todos los valores descritos en esta cotización están antes de IVA
                </Typography>
            </Box>


            {(data && data.length > 0) && <TablaCotizacionCliente data={data} />}

            <Grid container sx={{mb:3, mt:4, display:'flex', justifyContent:'center' }}>
                <Grid item xs={12} sm={6} md={5}>
                    <BotonesAndCargando
                        cargando={cargando}
                        titulo='Descargar'
                        titulo2="Loading..."
                        icon1="descargar"
                        icon2="descargar"
                        handleSubmit={ generarCotizacionCarrito }
                    />
                </Grid>
            </Grid>
        </LayoutCrearDoc>
    )
}
